export default "__VITE_ASSET__CbRdSQym__"